<template>
  <v-row :style="{marginLeft: '0.1rem !important'}">
    <v-col
      cols=2
      :style="{
        display: 'flex !important',
        flexDirection: 'column !important',
        alignItems: 'start !important',
        justifyContent: 'center !important',
        paddingLeft: '1rem !important'
      }"
    >
      <v-row
        :style="{
          flex: 'none !important'
        }"
      >
        <p>{{ data.hour }}</p>
      </v-row>
      <v-row
        :style="{
          flex: 'none !important'
        }"
      >
      </v-row>
    </v-col>
    <v-col>
      <v-card
        :class="getBackgroundColor()"
        :style="{padding: '0px !important', paddingLeft: '1rem !important'}"
      >
      <v-col>
        <v-row>
          <v-card
          color="#F5F5F5"
          width="100%"
          :style="{
            boxShadow: 'none !important'}"
          >
            <v-col
              :style="{padding: '10px'}">
              <v-row>
                <h4
                  :style="{margin: '1rem', fontSize: '14px !important'}">
                  {{ data.affectedCI }}
                  <span class="areaWeb" v-if="isParada && data.area!== ''">
                    &ensp;-&ensp;{{data.area}}
                  </span>
                </h4>
             </v-row>
             <v-row :style="{margin: '0'}">
              <span v-if="!isParada
              && data.ca_site_description
              && !this.$getConst('pulsoDigital.listadoCIExcepcional').includes(data.affectedCI)"
                :style="{marginLeft: '1rem', fontSize: '14px !important'}">
                {{data.ca_site_description}}
              </span>
              <span
              v-if="this.$getConst('pulsoDigital.listadoCIExcepcional').includes(data.affectedCI)"
                :style="{marginLeft: '1rem', fontSize: '14px !important'}">
                {{ data.localizacion }}
              </span>
            </v-row>
              <v-row>
                <h4 v-if="isParada && data.area !== ''"
                  class="areaMovil"
                  :style="{
                    display: 'none', marginLeft: '1rem',
                    marginTop: '0.5 rem', marginBottom: '1rem',
                    marginRight: '1rem', fontSize: '14px !important'}">
                  {{data.area}}
                </h4>
              </v-row>
              <v-row
                align="center"
                justify="space-between"
                :style="{margin: 0, gap:'2rem'}">
                <v-col>
                  <v-row
                    align="center"
                    :style="{paddingTop: '0.1rem', gap: '1rem !important',
                    marginBottom: '1px !important'}">
                    <p
                    v-if=isParada
                    class="paragraph"
                    :style="{marginTop: '3px', marginLeft:'12px'}">
                      Fecha de fin: {{ data.endDate }}
                    </p>
                  </v-row>
                  <v-row
                    align="center"
                    :style="{marginTop: '1px !important'}">
                    <v-col :style="{paddingBottom: '0px'}">
                      <v-chip :color="stateColor(data.status)"
                        class="text-h6 col-auto">
                        <p class="paragraph">
                          {{ $t(`views.pulsoDigital.statuses['${data.status}']`) }}
                        </p>
                      </v-chip>
                    </v-col>
                    <v-col>
                      <v-row
                        align="center"
                        justify="space-between"
                        :style="{
                          margin: 0,
                          gap:'2rem',
                          paddingLeft: '1rem',
                          paddingTop: '12px',
                          justifyContent: 'end !important'}">
                          <div :style="{
                            display: 'flex',
                            gap: '2rem'
                          }">
                            <v-btn
                              icon
                              title="Seguir"
                              id="no-background-hover"
                              @click="createSuscription"
                            >
                              <v-icon size="30">icon-ayudadigital-ojo-negativo</v-icon>
                            </v-btn>
                            <v-btn
                              v-if="!onlyAccessPulso"
                              v-show="isParada || (!isParada && isUserTic)"
                              icon
                              title="Ver detalles"
                              id="no-background-hover"
                              @click="navigateToDetail"
                            >
                              <v-icon size="30">icon-ayudadigital-info</v-icon>
                            </v-btn>
                            <v-btn
                              v-show="!isParada && isUserTic"
                              icon
                              title="Ver mapa"
                              id="no-background-hover"
                              @click="navigateToMap"
                            >
                              <v-icon size="30">icon-ayudadigital-chincheta</v-icon>
                            </v-btn>
                          </div>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-card>
        </v-row>
      </v-col>
    </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    data: Object,
  },
  computed: {
    isParada() {
      return this.data.category === process.env.VUE_APP_PULSO_DIGITAL_CATEGORY_PARADA_PLANIFICADA;
    },
    isUserTic() {
      const user = this.$store.getters['session/user'];
      return user.accessTypeTic;
    },
    colors() {
      return this.$getConst('dashboard.filtersColors');
    },
    stateColor() {
      return (state) => {
        let newState = state;
        if (state === 'RCHZ') {
          newState = 'DRCHZ';
        }
        return this.colors[newState] || '#a40e0e';
      };
    },
  },
  data() {
    return {
      suscriptorList: [],
      codigoSeguidor: 400002,
      onlyAccessPulso: false,
    };
  },
  methods: {
    getBackgroundColor() {
      const item = this.data;
      if (item.category === process.env.VUE_APP_PULSO_DIGITAL_CATEGORY_PARADA_PLANIFICADA) {
        return 'pa-4 paradaBoxShadow cardBox';
      }

      return 'pa-4 redBoxShadow cardBox';

      /*
      switch (item.priority) {
      case 5: return 'pa-4 priority1BoxShadow cardBox';
      case 4: return 'pa-4 priority2BoxShadow cardBox';
      case 3: return 'pa-4 priority3BoxShadow cardBox';
      default: return 'pa-4 redBoxShadow cardBox';
      }
      */
    },
    navigateToDetail() {
      const idTicketAux = this.data.persid;
      const idTicket = idTicketAux.substring(3);

      this.$router.push({
        name: 'TicketDetailTicView',
        params: {
          idTicket,
          pulsoDataExt: this.data,
          isTIC: true,
        },
      });
    },
    navigateToMap() {
      this.$router.push({
        name: 'PulsoDigitalMap',
        params: {
          id: `${this.data.REF_NUM} ${this.data.nombreRecursoDetalle}`,
        },
      });
    },
    async createSuscription() {
      const messageId = await this.$store.dispatch(
        'messages/createNotificationMessage',
        {
          icon: 'progress-circular',
          title: this.$t('views.pulsoDigital.addSubscription'),
        },
      );
      await this.getSuscriptor();
      const isSuscriptor = this.getSeguidor();
      if (!isSuscriptor) {
        await this.addSuscriptor({ messageId });
      } else {
        this.$store.dispatch('messages/updateMessage', {
          id: messageId,
          type: 'success',
          icon: 'mdi-close-circle',
          title: this.$t('views.pulsoDigital.errorSubscription'),
          timeout: this.$getConst('notifications.timeout'),
        });
      }
    },
    async getSuscriptor() {
      const { REF_NUM: referenceNumber } = this.data;
      const uuidAplicacionOrigen = this.$getConst('uuidAplicacion.origen');

      try {
        const { id, userid } = this.$store.getters['session/user'];
        const response = await this.suscriptorsClient.getListSuscriptorsSolicitud({
          apiCges: {
            delegado: userid,
            uuidSuscriptor: id,
            endpoint: `cges/solicitudes/${ referenceNumber }/suscriptores?uuidAplicacionOrigen=${ uuidAplicacionOrigen }`,
          },
          id: referenceNumber,
        });

        if (response?.collection_suscriptors?.suscriptors.length > 0) {
          this.suscriptorList = response.collection_suscriptors.suscriptors.map((item) => ({
            name: item.nombre,
            uuid: item.uuid,
            codigoFlujo: item.flujo.id,
          }));
        }
      } catch (error) {
        console.log(error);
      }
    },
    getSeguidor() {
      const { id } = this.$store.getters['session/user'];
      console.log('NOTICECOMPONENT', this.suscriptorList);
      const segudorOnly = this.suscriptorList
        .filter((item) => item.codigoFlujo === this.codigoSeguidor);

      return segudorOnly
        .some((suscriptor) => suscriptor.uuid === id);
    },
    async addSuscriptor({ messageId }) {
      const { REF_NUM: referenceNumber } = this.data;
      const { persid: persidAux } = this.data;
      const ticketID = persidAux.replace(/\D/g, '');
      try {
        const { id, userid, name } = this.$store.getters['session/user'];

        const idTagApp = this.$getConst('tagActivity.follow.idTagApp');
        const idTagWeb = this.$getConst('tagActivity.follow.idTagWeb');
        const isMobile = this.$store.getters['globalState/get']('deviceOS') != null;
        const tagActivity = isMobile ? idTagApp : idTagWeb;

        const descriptionActivity = `${name} ha seguido esta solicitud`;
        console.log('this.codigoSeguidor', this.codigoSeguidor);
        const response = await this.suscriptorsClient.postSuscriptors({
          apiCges: {
            delegado: userid,
            uuidSuscriptor: id,
            endpoint: `cges/solicitudes/${ referenceNumber }/suscriptores`,
          },
          id: referenceNumber,
          suscriptorAll: id,
          flujo: {
            id: this.codigoSeguidor,
          },
          descriptionActivity,
          zvirtualActivity: id,
          tagActivity,
          ticketID,
        });

        if (response.status === 200) {
          this.$store.dispatch('messages/updateMessage', {
            id: messageId,
            type: 'success',
            icon: 'mdi-check-circle',
            title: `${this.$t('views.pulsoDigital.createSubscription')}`,
            timeout: this.$getConst('notifications.timeout'),
          });
        } else {
          this.$store.dispatch('messages/updateMessage', {
            id: messageId,
            type: 'error',
            icon: 'mdi-close-circle',
            title: this.$t('views.pulsoDigital.koSubscription'),
            timeout: this.$getConst('notifications.timeout'),
          });
        }
      } catch (error) {
        this.$store.dispatch('messages/updateMessage', {
          id: messageId,
          type: 'error',
          icon: 'mdi-close-circle',
          title: this.$t('views.pulsoDigital.koSubscription'),
          timeout: this.$getConst('notifications.timeout'),
        });
      }
      this.$emit('input');
    },
  },
  created() {
    this.suscriptorsClient = this.$api.getClient('suscriptors');
  },
  mounted() {
    this.onlyAccessPulso = localStorage.getItem('onlyAccessPulso');
  },
};
</script>

<style scoped>
.v-btn--icon {
  height: 0 !important;
  width: 0 !important;
}
.paragraph {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
}
.paradaBoxShadow {
  background-color: #DEEBFF !important;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
  0px 2px 2px 0px rgba(0, 0, 0, 0.14),
  0px 1px 5px 0px #9ca5b3 !important;
}
.redBoxShadow {
  background-color: #ff0022 !important;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
  0px 2px 2px 0px rgba(0, 0, 0, 0.14),
  0px 1px 5px 0px #EC7D88 !important;
}

.priority3BoxShadow {
  background-color: #F9F1BC !important;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
  0px 2px 2px 0px rgba(0, 0, 0, 0.14),
  0px 1px 5px 0px #aca682  !important;
}

.priority2BoxShadow {
  background-color: #F4D4AA !important;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
  0px 2px 2px 0px rgba(0, 0, 0, 0.14),
  0px 1px 5px 0px #f88d00  !important;
}

.priority1BoxShadow {
  background-color: #FF7858 !important;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
  0px 2px 2px 0px rgba(0, 0, 0, 0.14),
  0px 1px 5px 0px #b3533d  !important;
}

.cardBox {
  width: fit-content !important;
}

@media only screen and (max-width: 785px) {
  .cardBox {
    width: auto !important;
  }

  .areaWeb {
    display: none;
  }
  .areaMovil {
    display: block !important;
  }
}
</style>
